import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useAppointments() {
  const [todayCount, setTodayCount] = useState(0);

  useEffect(() => {
    fetchTodayCount();

    const channel = supabase
      .channel('appointments-stats')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'appointments' },
        () => {
          fetchTodayCount();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  const fetchTodayCount = async () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const { count } = await supabase
      .from("appointments")
      .select("*", { count: "exact", head: true })
      .gte("start_time", today.toISOString())
      .lt("start_time", tomorrow.toISOString())
      .neq("status", "cancelled");

    setTodayCount(count || 0);
  };

  return { todayCount };
}
